import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import './MessageBox.css';
import React from 'react';
import FocusableButton from 'components/common/FocusableButton';

export default function MessageBox(props) {
  const {
    id,
    reference, // no use
    placement, // 'screen-center'
    connection, // 'none'
    width, // integer | 'auto'
    height, // integer | 'auto'
    veilable, // no use
    stickable, // no use
    movable, // true
    closable, // Boolean
    modal, // true
    dim, // color (default=transparent)
    tags = [], // optional
    type,
    title, // optional
    description, // optional
    contents, // required
    buttons = [], // required
    events = {}, // required
    close,
    ...rest
  } = props || {};

  React.useEffect(() => {
    events.onMount && events.onMount(props);
    return () => {
      events.onUnmount && events.onUnmount(props);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ref = React.useRef();

  return (
    <div
      {...ex('Dim')}
    >
      <div
        {...ex(['MessageBox', placement], rest)}
        {...{ ref }}
      >
        {title && (
          <div {...ex('MessageBoxTitle')}>
            {title}
          </div>
        )}
        {description && (
          <div {...ex('MessageBoxDescription')}>
            {description}
          </div>
        )}
        <div {...ex('MessageBoxContents')}>
          {contents}
        </div>
        <div {...ex('MessageBoxButtons')}>
          {buttons.map(button => {
            const {
              autoFocus,
              caption,
              event,
              ...buttonProps
            } = button;
            return (
              <FocusableButton
                key={caption}
                {...buttonProps}
                {...{
                  autoFocus,
                  onClick: events[event],
                }}
              >
                {caption}
              </FocusableButton>
            );
          })}
        </div>
      </div >
    </div>
  );
}
